import {
  Component,
  OnInit,
  Input,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter
} from '@angular/core'
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  FormArray
} from '@angular/forms'
import { BsModalRef, BsModalService } from 'ngx-bootstrap'
import { Subscription } from 'rxjs/Subscription'
import { StoreService } from 'app/service/store.service'
import { CpmService } from 'app/service/cpm.service'
import { ActivatedRoute } from '@angular/router'
import { AuthorizeService } from '../../../service/authorize.service'
import { ToastrService } from '../../../../../node_modules/ngx-toastr';
@Component({
  selector: 'app-other-action',
  templateUrl: './other-action.component.html',
  styleUrls: ['./other-action.component.scss']
})
export class OtherActionComponent implements OnInit {
  @Input() printPage
  @Output() refreshParentScreen: EventEmitter<any> = new EventEmitter()

  @ViewChild('templateDel') templateDel: TemplateRef<any>
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  modalRef: BsModalRef
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }
  isAE
  listItem = []
  listOption = [
    { value: 'EJIP', detail: 'EJIP' },
    { value: 'MA', detail: 'M&A' },
    { value: 'GM', detail: 'General mandate' },
    { value: 'Others', detail: 'Others' }
  ]

  listHead = ['Type', 'Date', 'Detail']
  otherForm: FormGroup
  id
  editFlag = false
  listDelete = []
  listAdd = []
  subscription: Subscription
  symbol
  message
  constructor(
    private fb: FormBuilder,
    private store: StoreService,
    private cpmService: CpmService,
    private modalService: BsModalService,
    private authorization: AuthorizeService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.createForm()
    this.subscription = this.store
      .getSecurityProfileNewResultObservable()
      .subscribe(response => {
        if (!response) {
          return
        }
        this.symbol = response['securitySymbol']
        this.isAE = response['ae']
        this.cpmService.getCorporateActionOther(this.symbol).subscribe(obj => {
          this.listItem = []
          this.rebuildForm()
          obj.map(other => {
            this.listItem.push(other)
          })
          this.setUpForm(this.listItem)
        })
      })
  }

  get isUserHasPermission(): Boolean {
    return (
      this.authorization.hasRole('COMPINFO_EDIT')
    )
  }

  createForm() {
    this.otherForm = this.fb.group({
      // mode: new FormControl('I'),
      items: this.fb.array([])
    })
  }

  setUpForm(listItem) {
    listItem.map(item => {
      // this.otherForm.get('mode').setValue('U')
      const obj = new OrthetObj()
      obj.id = item.id
      obj.corporateActionType = item.corporateActionType
      obj.effectiveDate = new Date(item.effectiveDate)
        .toISOString()
        .slice(0, -1)
      obj.detail = item.detail
      obj.securitySymbol = this.symbol
      obj.corporateActionTypeDeatil = this.listOption.find(
        corporate => corporate.value === item.corporateActionType
      ).detail
      this.items.push(this.fb.group(obj))
    })
  }

  setEditFlag() {
    if (this.items.length === 0) {
      this.addItem()
    }
    this.editFlag = true
  }

  addItem() {
    const obj = new OrthetObj()
    obj.id = ''
    obj.corporateActionType = ['', Validators.required]
    obj.effectiveDate = new Date().toISOString().slice(0, -1)
    obj.detail = ''
    obj.securitySymbol = this.symbol
    obj.corporateActionTypeDeatil = ''

    this.items.push(this.fb.group(obj))
  }
  get items(): FormArray {
    return this.otherForm.get('items') as FormArray
  }
  onDelete(index) {
    const idDelete = this.items.controls[index].get('id').value
    const tmp = idDelete === '' ? null : this.listDelete.push(idDelete)
    this.items.removeAt(index)
  }
  onCancel() {
    this.editFlag = false
    this.rebuildForm()
    this.ngOnInit()
  }

  rebuildForm() {
    this.otherForm.reset({})
    this.setItems(this.listItem)
  }

  setItems(listItem) {
    const itemFGs = listItem.map(item =>
      this.fb.group({
        id: item.id,
        corporateActionType: item.corporateActionType,
        effectiveDate: item.effectiveDate,
        detail: item.detail,
        securitySymbol: this.symbol,
        corporateActionTypeDeatil: this.listOption.find(
          corporate => corporate.value === item.corporateActionType
        ).detail
      })
    )

    const itemFormArray = this.fb.array(itemFGs)
    this.otherForm.setControl('items', itemFormArray)
  }
  getCorporateActionTypeDeatil(corporateActionType) {
    return this.listOption.find(
      corporate => corporate.value === corporateActionType
    ).detail
  }

  onSubmit() {
    this.listAdd = []
    if (this.otherForm.valid) {
      this.items.controls.filter(obj => obj.pristine === false).map(item => {
        item
          .get('corporateActionTypeDeatil')
          .setValue(
            this.getCorporateActionTypeDeatil(
              item.get('corporateActionType').value
            )
          )

        const data = {
          id: item.value.id,
          securitySymbol: this.symbol,
          detail: item.value.detail,
          effectiveDate: item.value.effectiveDate,
          caType: item.value.corporateActionType
        }

        this.listAdd.push(data)
      })

      const putData = {
        delete: this.listDelete,
        add: this.listAdd,
        securitySymbol: this.symbol
      }

      const formData = new FormData()
      formData.append(
        'updateField',
        new Blob([JSON.stringify(putData)], { type: 'application/json' })
      )

      this.cpmService.updateOtherCA(formData).subscribe(
        success => {
          this.message = success.status
          this.message === 'OK'
            ? (this.toastr.success('การบันทึกรายการสำเร็จแล้ว'))
            : (this.message = 'บันทึกรายการไม่สำเร็จ')
          this.refreshParentScreen.emit('')
        },
        error => {
          this.message = 'บันทึกรายการไม่สำเร็จ'
          this.openModal(this.templateSaved)
        }
      )
    }
    this.editFlag = false
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }
  public goBack() {
    this.modalRef.hide()
  }
  noInfomationOtherAction() {
    let noData
    this.items.controls.length === 0 ? (noData = true) : (noData = false)
    return noData
  }
  clickEditDropdown(event: Event) {
    $(event.target)
      .closest('div')
      .next()
      .toggleClass('show')
  }

  mourseLeaveMenu() {
    $(event.target)
      .find('#editItemListOtherAction')
      .removeClass('show')
  }
}
export class OrthetObj {
  id: any
  corporateActionType: any
  corporateActionTypeDeatil: any
  effectiveDate = ''
  detail = ''
  securitySymbol: any
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/securities-level/corporate-action/other-action/other-action.component.ts